import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

export function RenameBenefitDialog({ label, count, onClose, onSaved }) {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setName(label || ""); }, [label]);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/benefits/rename", { old_label: label, new_label: name });
      toast.success(`Benefício renomeado para "${data.label}" (${data.employees} funcionário(s))`);
      onClose(); onSaved?.(data.label);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!label} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="rename-benefit-dialog">
        <DialogHeader><DialogTitle>Renomear benefício</DialogTitle>
          <DialogDescription>O novo nome vale para todos os {count} funcionário(s) com "{label}", nos limites e no Excel. Valores e vigências não mudam.</DialogDescription></DialogHeader>
        <Input value={name} maxLength={60} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} data-testid="rename-benefit-input" autoFocus />
        <DialogFooter><Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={save} disabled={busy || name.trim().length < 2 || name.trim() === label} data-testid="rename-benefit-save">{busy ? "Salvando..." : "Renomear"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>);
}
